import { styled } from 'styled-components';

const Chevron = ({ className }: { className?: string }) => (
  <svg className={className} width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.67619 1.29574L10.9795 6.59904L5.67619 11.9023" stroke="currentColor" strokeWidth="2" />
  </svg>
);
export default styled(Chevron)``;
